import config from '@/config';
import Http from './Http';
import LocalStorage from './LocalStorage';

const client = new Http('', config.api);

/*
 * @param {string} email - The email address to send the password reset link to.
 * @returns {Promise} - A promise that resolves when the email is sent.
 */
client.getUser = () => client.get('me');

client.createAvatar = (formData) => client.post(formData, 'me/avatar', '');
client.deleteAvatar = (id) => client.delete(id);

/*
 * @param {string} email - The email address to send the password reset link to.
 * @returns {Promise} - A promise that resolves when the email is sent.
 */
client.resendConfirmation = () =>
  client.post(null, 'me/resend-email-verification');

/*
 * @param {string} email - The email address to send the password reset link to.
 * @returns {Promise} - A promise that resolves when the email is sent.
 */
client.setUser = (user) =>
  client.patch('me', {
    name: user.name,
    phone: user.phone,
    cpf: user.cpf,
  });

/*
 * @param {string} email - The email address to send the password reset link to.
 * @returns {Promise} - A promise that resolves when the email is sent.
 */
client.updatePassword = (currentPassword, password) =>
  client.put('me/password', {
    current_password: currentPassword,
    password,
  });

/*
 * @param {string} email - The email address to send the password reset link to.
 * @returns {Promise} - A promise that resolves when the email is sent.
 */
client.logout = () => client.post('', config.logoutPath);

/*
 * @param {string} language - The language code to set as the preference.
 * @returns {Promise} - A promise that resolves when the language is updated.
 */
client.updateLanguage = async (language) => {
  try {
    const response = await client.post({ lang: language }, 'me/language', '');
    LocalStorage.set('language', language);
    return response;
  } catch (error) {
    console.error('❌ Error updating preference language:', error);
    throw new Error('Error updating preference language: ' + error.message);
  }
};

/*
 * @param {string} email - The email address to send the password reset link to.
 * @returns {Promise} - A promise that resolves when the email is sent.
 */
client.loadAndPersistUser = (user) => {
  if (!user) {
    console.warn('⚠️ loadAndPersistUser called without user');
    return;
  }

  if (user.lang) {
    LocalStorage.set('language', user.lang);
  }

  LocalStorage.set('user', {
    name: user?.name,
    email: user?.email,
  });
};

export default client;
